import React from 'react';
import PillToggle from '../PillToggle/PillToggle';

interface LanguageCompletionProps {
  languageCode: string;
  languageName: string;
  isCompleted: boolean;
  onToggleComplete: (languageCode: string) => void;
}

const LanguageCompletion: React.FC<LanguageCompletionProps> = ({
  languageCode,
  languageName,
  isCompleted,
  onToggleComplete
}) => {
  return (
    <PillToggle
      label={languageName}
      isSelected={isCompleted}
      onToggle={() => onToggleComplete(languageCode)}
      size="small"
    />
  );
};

export default LanguageCompletion; 